import type { ReactNode } from "react";

import { cn } from "../../helpers";
import { body, paragraph, title as titleStyles } from "../typography";
import * as styles from "./message-card.styled";
import type { MessageCardVariant } from "./message-card.styled";

export type { MessageCardVariant } from "./message-card.styled";

type MessageCardProps = {
  title?: ReactNode;
  description: ReactNode;
  hasSecondDescription?: ReactNode;
  illustration?: ReactNode;
  cta?: ReactNode;
  link?: ReactNode;
  className?: string;
  variant?: MessageCardVariant;
  titleAs?: "body" | "title";
  illustrationPosition?: "left" | "right";
  extraVerticalPadding?: boolean;
  animated?: boolean;
};

export const MessageCard = ({
  description,
  hasSecondDescription,
  title,
  cta,
  link,
  className,
  illustration,
  variant = "default",
  titleAs = "body",
  illustrationPosition = "left",
  extraVerticalPadding = false,
  animated = true,
}: MessageCardProps) => {
  const titleClass =
    titleAs === "title" ? titleStyles({ size: "xxs" }) : body({ size: "sm" });
  return (
    <div
      className={styles.root(variant, className, {
        extraVerticalPadding,
        animated,
      })}
    >
      {illustrationPosition === "left" ? illustration : null}
      <div className={styles.contentContainer}>
        <div
          className={styles.titleAndDescriptionContainer(
            Boolean(title),
            variant,
          )}
        >
          {title ? (
            <p className={cn(titleClass, styles.title(variant))}>{title}</p>
          ) : null}
          <div
            className={styles.descriptionContainer(
              Boolean(hasSecondDescription),
            )}
          >
            <p
              className={cn(
                paragraph({ size: "sm" }),
                styles.description(variant),
              )}
            >
              {description}
            </p>
            {link ? link : null}
            {hasSecondDescription ? (
              <p className={paragraph({ size: "sm" })}>
                {hasSecondDescription}
              </p>
            ) : null}
          </div>
        </div>
        {cta ? <div className={styles.ctaContainer}>{cta}</div> : null}
      </div>
      {illustrationPosition === "right" ? illustration : null}
    </div>
  );
};
